import { createSlice } from "@reduxjs/toolkit";

const defaultState = {
  search_input: "",
  searchModes: ["Date", "Audit", "Session Audit"],
  rawData: [],
  storeData: [],
  sessionAuditList: [],
  userList: [],
  storeList: [],
  selectedOption: {
    user: "",
    store: "",
    session_audit: "",
  },
  selectedType: "category",
  audits: [],
  selectedAudit: "",
  imageDetails: [],
  annotationDetails: [],
  skuInfoRaw: [],
  brands: [],
  variants: [],
  skus: [],
};

export const defaultTabSlice = createSlice({
  name: "defaultTab",
  initialState: {
    currentSearchMode: "Date",
    ...defaultState,
  },
  reducers: {
    handleInput(state, action) {
      state.search_input = action.payload;
    },
    setStoreData(state, action) {
      state.storeData = action.payload;
    },
    setRawData(state, action) {
      state.rawData = action.payload;
    },
    setSessionAuditList(state, action) {
      state.sessionAuditList = action.payload;
    },
    setUserList(state, action) {
      state.userList = action.payload;
    },
    setStoreList(state, action) {
      state.storeList = action.payload;
    },
    setAuditList(state, action) {
      state.audits = action.payload;
    },
    setSelectedAudit(state, action) {
      state.selectedAudit = action.payload;
    },
    setImageDetails(state, action) {
      state.imageDetails = action.payload;
    },
    setAnnotationDetails(state, action) {
      state.annotationDetails = action.payload;
    },
    setSelectedOption(state, action) {
      state.selectedOption = action.payload;
    },
    setSkuInfoRaw(state, action) {
      state.skuInfoRaw = action.payload;
    },
    setBrands(state, action) {
      state.brands = action.payload;
    },
    setVariants(state, action) {
      state.variants = action.payload;
    },
    setSkus(state, action) {
      state.skus = action.payload;
    },
    setSelectedType(state, action) {
      state.selectedType = action.payload;
    },
    resetDefaultTabStateToDefault(state, action) {
      const updatedState = { ...state, ...defaultState };
      return updatedState;
    },
    changeSearchMode(state, action) {
      state.currentSearchMode = action.payload;
    },
  },
});
